module.exports = __webpack_public_path__ + "img/carrousel-mamo-5.0d200583.jpg";